export default {
  apiVersion: 2,
  development: {
    accessToken: '2c045ed61f496f3e2cac1d46aaff360a',
    url: 'http://api.gallerypizza.dev.moya.is/_/moya/pilot/api',
  },
  staging: {
    accessToken: '2c045ed61f496f3e2cac1d46aaff360a',
    url: 'https://api.gallerypizza.is/_/moya/pilot/api',
  },
  production: {
    accessToken: '2c045ed61f496f3e2cac1d46aaff360a',
    url: 'https://api.gallerypizza.is/_/moya/pilot/api',
  },
};
